/*
 * @Author: bz2021
 * @Date: 2025-07-01 19:37:49
 * @Description:
 */

import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgetPwd";
import Home from "./pages/Home";
import UserList from "./pages/UserList";
import MyUserList from "./pages/MyUserList";
import StoreManagement from "./pages/StoreManagement";
import ProductDetailPage from "./pages/ProductDetailPage";
import MainLayout from "./layout/MainLayout";
import MyShop from "./pages/MyShop";
import Test from "./pages/TestPage";
import ShopDetails from "./pages/ShopDetails";
import MyShopTwo from "./pages/MyShopTwo";
import ElectronicTicket from "./pages/ElectronicTicket";

const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/forget", element: <ForgotPassword /> },
  { path: "/my-shop", element: <MyShop />},
  { path: "/test", element: <Test />},
  { path: "/shop-details", element: <ShopDetails />},
  { path: "/electronic-ticket", element: <ElectronicTicket />},
  {path: "/my-shop-two", element: <MyShopTwo />},
  { path: "/", element: <MainLayout />, children: [
    { path: "/", element: <Navigate to="/my-shop" replace /> },
    { path: "home", element: <Home /> },
    { path: "users", element: <UserList /> },
    { path: "my_users", element: <MyUserList /> },
    { path: "store_management", element: <StoreManagement /> },
    { path: "product-detail", element: <ProductDetailPage /> }
  ]}
]);

export default router;
